import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon, Modal } from '@vectord/components';

import {
  setUpdateInstructorsModalState,
  updateInstructorsModalStateSelector,
} from 'features/classCreation';
import BulkUpdateInstructorsModalContent from '../BulkUpdateInstructorsModalContent';
import SectionHeading from 'components/SectionHeading';
import SelectedSbatGroupsForBulkUpdate from '../SelectedSbatGroupsForBulkUpdate';
import styles from './BulkUpdateInstructorsModal.module.scss';

function BulkUpdateInstructorsModal() {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(updateInstructorsModalStateSelector);

  const handleModalClose = useCallback(() => {
    dispatch(setUpdateInstructorsModalState(false));
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      withoutHeader
      onClose={handleModalClose}
      unMountOnClose
      className={styles.root}
      size="large"
    >
      <SectionHeading
        title={
          <>
            <Icon
              name="swap-role"
              className="m-r-xxs"
            />
            Change Instructor
          </>
        }
        titleClassName={styles.heading}
        className={styles.sectionHeading}
      />
      <SelectedSbatGroupsForBulkUpdate
        highlightContests
        isInstructorModal
      />
      <BulkUpdateInstructorsModalContent />
    </Modal>
  );
}

export default BulkUpdateInstructorsModal;
